import { useEffect, useRef } from "react";
import createGlobe from "cobe";

import avatarOne from "../../../assets/personas/avatars/avatar (4).png";
import avatarTwo from "../../../assets/personas/avatars/avatar (5).png";
import avatarThree from "../../../assets/personas/avatars/avatar (6).png";

const activity = [
  {
    id: "miami",
    location: [25.7617, -80.1918],
    name: "Maya",
    city: "Miami, EUA",
    avatar: avatarOne,
    className: "global-ping ping-one",
  },
  {
    id: "lisbon",
    location: [38.7223, -9.1393],
    name: "Beatriz",
    city: "Lisboa, PT",
    avatar: avatarTwo,
    className: "global-ping ping-two",
  },
  {
    id: "sydney",
    location: [-33.8688, 151.2093],
    name: "Sophie",
    city: "Sydney, AU",
    avatar: avatarThree,
    className: "global-ping ping-three",
  },
  {
    id: "sao-paulo",
    location: [-23.5505, -46.6333],
    name: "Lucas",
    city: "São Paulo, BR",
    avatar: avatarOne,
    className: "global-ping ping-four",
  },
  {
    id: "mexico-city",
    location: [19.4326, -99.1332],
    name: "Mateo",
    city: "Cidade do México, MX",
    avatar: avatarTwo,
    className: "global-ping ping-five",
  },
  {
    id: "london",
    location: [51.5072, -0.1276],
    name: "Emily",
    city: "Londres, UK",
    avatar: avatarThree,
    className: "global-ping ping-six",
  },
];

const markers = [
  ...activity.map(({ id, location }) => ({ id, location, size: 0.055 })),
  { location: [43.6532, -79.3832], size: 0.048 },
  { location: [40.4168, -3.7038], size: 0.048 },
  { location: [35.6762, 139.6503], size: 0.048 },
  { location: [-34.6037, -58.3816], size: 0.048 },
  { location: [-33.9249, 18.4241], size: 0.048 },
  { location: [1.3521, 103.8198], size: 0.048 },
  { location: [25.2048, 55.2708], size: 0.048 },
  { location: [4.711, -74.0721], size: 0.048 },
];

export default function GlobalGlobe() {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const container = containerRef.current;
    if (!canvas || !container) return undefined;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    let phi = 0.18;
    let width = container.offsetWidth;
    let visible = true;
    let animationFrame;

    const globe = createGlobe(canvas, {
      devicePixelRatio: Math.min(window.devicePixelRatio || 1, 2),
      width: width * 2,
      height: width * 2,
      phi,
      theta: 0.2,
      dark: 1,
      diffuse: 1.7,
      mapSamples: 16000,
      mapBrightness: 9,
      baseColor: [0.48, 0.48, 0.48],
      markerColor: [1, 1, 1],
      glowColor: [0.14, 0.14, 0.14],
      markers,
    });

    const render = () => {
      if (visible) {
        phi += 0.0017;
        globe.update({ phi });
      }
      animationFrame = window.requestAnimationFrame(render);
    };

    if (!prefersReducedMotion) render();

    const resizeObserver = new ResizeObserver(() => {
      width = container.offsetWidth;
      globe.update({ width: width * 2, height: width * 2 });
    });
    resizeObserver.observe(container);

    const intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        visible = entry.isIntersecting;
      },
      { rootMargin: "120px" }
    );
    intersectionObserver.observe(container);

    return () => {
      window.cancelAnimationFrame(animationFrame);
      resizeObserver.disconnect();
      intersectionObserver.disconnect();
      globe.destroy();
    };
  }, []);

  return (
    <div className="global-globe" ref={containerRef}>
      <canvas
        ref={canvasRef}
        className="global-globe-canvas"
        aria-label="Globo mostrando vendas de produtos fitness em diferentes países"
      />
      {activity.map((item) => (
        <div
          className={item.className}
          key={item.id}
          style={{
            positionAnchor: `--cobe-${item.id}`,
            opacity: `var(--cobe-visible-${item.id}, 0)`,
          }}
          aria-label={`Novo membro: ${item.name}, ${item.city}`}
        >
          <img src={item.avatar} alt="" />
          <span>
            <strong>Novo membro</strong>
            <small>{item.name} · {item.city}</small>
          </span>
          <b>agora</b>
        </div>
      ))}
    </div>
  );
}
